import Vue from 'vue'
import App from './App.vue'
import router from './router'
import axios from 'axios'
import store from './store'
import ElementUI from 'element-ui'
import Swiper from 'swiper/dist/js/swiper.min.js'
import common from  './common'
import 'amfe-flexible'
import  './request'
import 'url-search-params-polyfill'
// import 'element-ui/lib/theme-chalk/reset.css'
// import 'element-ui/lib/theme-chalk/index.css'
// import  './assets/css/common.stylus'
import  './assets/css/assembly.stylus'
import  './assets/css/element-ui.stylus'
import 'font-awesome/css/font-awesome.css'
import 'swiper/dist/css/swiper.css'
import { Loading } from 'element-ui';
import '@/assets/css/public.css';
// import { websocket } from './assets/js/websocket.js'
// import { Pagination } from 'element-ui';
Vue.prototype.$swiper=Swiper
Vue.prototype.$ajax=axios
Vue.prototype.$common=common
Vue.config.productionTip = false
Vue.use(ElementUI)
// Vue.use(Pagination)
router.beforeEach((to, from, next) => {
  next() 
  window.scrollTo(0,0)
})
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
